export default __webpack_public_path__ + "static/media/background.764dda0e.jpg";